<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search">
                <div class="search_item">
                    <div class="title">
                        日期:
                    </div>
                    <div class="input_box">
                        <el-date-picker
                                v-model="searchDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                size="small"
                                @change="getAllData"
                                placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="btn_box">
                <span class="msg" v-if="showUpdateMsg">已更新...</span>
                <el-button size="small"
                           class="width_100"
                           :loading="update_loading"
                           @click="updateData">更新数据</el-button>
                <el-button size="small"
                           type="primary"
                           :loading="loadingDown"
                           @click="downExcel">导出</el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column type="index" label="序号" width="60" fixed="left"></el-table-column>
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index">
                    <template slot="header" slot-scope="scope">
                        <div class="table_title" v-if="item.showTemplate">
                            <div class="table_th_check" v-if="item.label === '所在BU'">
                                <table-search @popover_getTable="popover_getTable"
                                              :list="bu_list"
                                              search_name="BU"
                                              :label="item.label"
                                              :search_list="searchForm.BU">
                                </table-search>
                            </div>

                            <div class="table_th_check" v-if="item.label === '区域'">
                                <table-search @popover_getTable="popover_getTable"
                                              :list="region_list"
                                              search_name="region"
                                              :label="item.label"
                                              :search_list="searchForm.region">
                                </table-search>

                            </div>
                            <div class="table_th_check" v-if="item.label === '大区'">
                                <table-search @popover_getTable="popover_getTable"
                                              :list="district_list"
                                              search_name="district"
                                              :label="item.label"
                                              :search_list="searchForm.district">
                                </table-search>
                            </div>
                            <div class="table_th_check" v-if="item.label === '医院省份'">
                                <table-search @popover_getTable="popover_getTable"
                                              :list="province_list"
                                              search_name="province"
                                              :label="item.label"
                                              :search_list="searchForm.province">
                                </table-search>
                            </div>
                            <div class="table_th_check" v-if="item.label === '姓名'">
                                <table-search @popover_getTable="popover_getTable"
                                              search_name="name"
                                              :only_search="true"
                                              :label="item.label"
                                              :search_list="searchForm.name">
                                </table-search>
                            </div>

                            <div class="table_th_check" v-if="item.label === '职位'">
                                <table-search @popover_getTable="popover_getTable"
                                              :list="jobList"
                                              search_name="jobs"
                                              :label="item.label"
                                              :search_list="searchForm.jobs">
                                </table-search>
                            </div>
                            <div class="table_th_check" v-if="item.label === '注册状态'">
                                <table-search @popover_getTable="popover_getTable"
                                              :list="regList"
                                              search_name="regStatus"
                                              :not_search="true"
                                              :label="item.label"
                                              :search_list="searchForm.jobs">
                                </table-search>
                            </div>
                            <div class="table_th_check" v-if="item.label === '关注状态'">
                                <table-search @popover_getTable="popover_getTable"
                                              :list="subList"
                                              search_name="subStatus"
                                              :not_search="true"
                                              :label="item.label"
                                              :search_list="searchForm.jobs">
                                </table-search>
                            </div>
                        </div>
                        <div class="table_title" v-else>
                            <span>{{item.label}}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone, formatTime} from "@/global/utils";
    import {downGet} from "@/api";
    import tableSearch from "./table_search"

    export default {
        name: "tableView",
        components: {tableSearch},
        data() {
            const registerStatus = (row, column, cellValue, index) => {
                return cellValue == '1' ? '未注册' :
                    cellValue == '2' ? '已注册' :
                        ''
            };
            const attentionStatus = (row, column, cellValue, index) => {
                return cellValue == '1' ? '未关注' :
                    cellValue == '2' ? '已关注' :
                        ''
            };
            return {
                currentPage: 1,
                pageSize: 50,
                total: 0,

                searchDate: '',
                loadingDown: false,

                update_loading: false,
                showUpdateMsg: false,

                searchForm: {
                    BU: [],
                    district: [],
                    region: [],
                    province: [],
                    jobs: [],
                    regStatus: [],
                    subStatus: [],

                    name: ''
                },
                status_list: [
                    {name: '不限', value: ''},
                    {name: '待审核', value: '1'},
                    {name: '已审核', value: '2'},
                    {name: '已拒绝', value: '3'},
                ],
                jobList: ['REP','DSM','RSM','SD',],
                regList: ['已注册', '未注册'],
                subList: ['已关注', '未关注'],

                bu_list: [],
                region_list: [],
                district_list: [],
                province_list: [],

                allTableData: [], // 总数据
                search_table: [], // 搜索之后的数据
                tableData: [], // 显示的数据 分页
                columnData: [
                    {width: 100, label: '所在BU', prop: 'bu', fixed: 'left', showTemplate: true},
                    {label: '区域', prop: 'region', fixed: 'left', showTemplate: true},
                    {label: '大区', prop: 'district', fixed: 'left', showTemplate: true},
                    {width: 100, label: '医院省份', prop: 'province', fixed: 'left', showTemplate: true},
                    {width: 90, label: '医院城市', prop: 'city', fixed: 'left'},
                    {width: 90, label: '岗位编码', prop: 'job',},
                    {label: '工号', prop: 'job_number',},
                    {label: '姓名', prop: 'name', showTemplate: true},
                    {label: '职位', prop: 'title', showTemplate: true},
                    {width: 100,label: 'DSM姓名', prop: 'dsm_name',},
                    {width: 100,label: 'RSM姓名', prop: 'rsm_name',},
                    {width: 100,label: '注册状态', prop: 'wx_reg', formatter: registerStatus, showTemplate: true},
                    {width: 100,label: '关注状态', prop: 'is_subscribed', formatter: attentionStatus, showTemplate: true},
                    {width: 120,label: '注册日期', prop: 'reg_date'},
                    {width: 120,label: '最后登录日期', prop: 'last_login_date'},
                    {label: '总计P', prop: 'patient_total'},
                    {width: 90,label: '已填报P', prop: 'fill_count'},
                    {width: 90,label: '未填报P', prop: 'reg_count'},
                    {width: 100,label: '疗程中P数', prop: 'ongoing_count'},
                    {width: 100,label: '待提醒P数', prop: 'remind_count'},
                    {width: 100,label: '已脱落P数', prop: 'lose_count'},
                    {label: '总支数', prop: 'medication_total'},
                    {width: 90,label: '平均DOT', prop: 'dot'},
                ]
            }
        },
        mounted() {
            let time = (new Date()).getTime() - 3600*1000*24;
            this.searchDate = formatTime(new Date(time)).time1;
            this.getFilterTH();
            this.getAllData();
        },
        methods: {
            getFilterTH() {
                this.httpGet('/stat_rep/filter_data').then(res => {
                    this.bu_list = res.data.bu_list.map(v =>  v =!v ? '其他' : v);
                    this.district_list = res.data.district_list.map(v =>  v =!v ? '其他' : v);
                    this.province_list = res.data.province_list.map(v =>  v =!v ? '其他' : v);
                    this.region_list = res.data.region_list.map(v =>  v =!v ? '其他' : v);
                })
            },
            getAllData() {
                let params = {
                    stat_date: this.searchDate
                };
                this.httpGet('/stat_rep', params).then(res => {
                    this.allTableData = res.data.data_list; // 基本数据 不变动
                    this.search_table = res.data.data_list; // 不搜索的情况下确保有数据
                    this.total = res.data.data_list.length;

                    this.searchForm = {
                        BU: [],
                        district: [],
                        region: [],
                        province: [],
                        jobs: [],
                        regStatus: [],
                        subStatus: [],

                        name: ''
                    }; // 切换日期后所有搜索条件清空
                    this.getTableData()
                });
            },
            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1, type) {
                if (type === 'search') {
                    let table = clone(this.allTableData);
                    if (this.searchForm.BU.length > 0) {
                        table = table.filter(v => {
                            return this.searchForm.BU.indexOf(v.bu) > -1
                        });
                    }
                    if (this.searchForm.region.length > 0) {
                        table = table.filter(v => {
                            return this.searchForm.region.indexOf(v.region) > -1
                        });
                    }
                    if (this.searchForm.district.length > 0) {
                        table = table.filter(v => {
                            return this.searchForm.district.indexOf(v.district) > -1
                        });
                    }
                    if (this.searchForm.province.length > 0) {
                        table = table.filter(v => {
                            return this.searchForm.province.indexOf(v.province) > -1
                        });
                    }
                    if (this.searchForm.jobs.length > 0) {
                        table = table.filter(v => {
                            return this.searchForm.jobs.indexOf(v.title) > -1
                        });
                    }
                    if (this.searchForm.regStatus.length > 0) {
                        let list = [];
                        this.searchForm.regStatus.forEach(v => {
                            let item = v === '未注册' ? 1 : '已注册'? 2 : '';
                            list.push(item)
                        });
                        table = table.filter(v => {
                            return list.indexOf(v.wx_reg) > -1
                        });
                    }
                    if (this.searchForm.subStatus.length > 0) {
                        let list = [];
                        this.searchForm.subStatus.forEach(v => {
                            let item = v === '未关注' ? 1 : '已关注'? 2 : '';
                            list.push(item)
                        });
                        table = table.filter(v => {
                            return list.indexOf(v.is_subscribed) > -1
                        });
                    }
                    if (this.searchForm.name) {
                        table = table.filter(v => {
                            return v.name.indexOf(this.searchForm.name) > -1
                        })
                    }
                    this.search_table = table;
                    this.total = table.length;
                }

                let start = (v - 1) * this.pageSize;
                let num = v * this.pageSize;
                let all = clone(this.search_table);
                this.tableData = all.slice(start, num);
                this.$nextTick(() => {
                    this.currentPage = v;
                })
            },

            popover_getTable(data) {
                console.log(data, '318');
                this.searchForm[data.name] = data.list;
                this.getTableData(1, 'search')
            },

            updateData() {
                this.update_loading = true;
                this.httpGet("/stat_rep/update_stat_repfill").then((res) => {
                    this.updatePolling();
                });
            },
            updatePolling() {
                let i = 0;
                let timer = setInterval(() => {
                    i++;
                    this.httpGet("/stat_rep/check_update_stat_repfill").then((res) => {
                        console.log("---",i);
                        if (res.data.finished) {
                            clearInterval(timer);
                            this.update_loading = false;
                            this.getAllData();
                            this.showUpdateMsg = true;
                            setTimeout(() => {this.showUpdateMsg = false;}, 3000)
                        }
                    });
                }, 5000);
            },

            downExcel() {
                console.log("exportData--------");
                let params = {
                    stat_date: this.searchDate
                };
                this.loadingDown = true;
                this.httpGet("/stat_rep/export", params).then((res) => {
                    this.exportPolling(res.data.job_id);
                });
            },
            exportPolling(job_id) {
                let i = 0;
                let timer = setInterval(() => {
                    i++;
                    this.httpGet("/stat_rep/check_export", {
                        job_id: job_id,
                    }).then((res) => {
                        console.log("---",i);
                        if (res.data.finished) {
                            clearInterval(timer);
                            this.loadingDown = false;
                            console.log("0----finished", res.data.url);
                            // var url = config.PRODUCTION_SERVER + "/pdfreport/" + data.pdf_name;
                            var url = res.data.url;
                            var $form = $('<form method="GET"></form>');
                            $form.attr("action", url);
                            $form.appendTo($("body"));
                            $form.submit();
                        }
                    });
                }, 1000);
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        .header {
            .btn_box {
                .msg {
                    font-size: .875rem;
                    padding: 0 10px;
                }
            }
        }
    }

    .dialog_search_box {
        margin-bottom: 5px;
    }

    .select_btn {
        line-height: 25px;
        .check_group_box {
            height: 600px;
            .checkbox_item {
                display: block;
                padding-left: 20px;
            }
        }

    }
    .btn {
        text-align: right;
    }
</style>